import axios from "axios";

export const state = {
    visit_profile: {},
    profile_status: false,
    order_service_status: false,
    ordered_consultations: [],
    ordered_procedure: [],
    ordered_radiologies: [],
    ordered_antenatal: [],
    ordered_debtal: [],
    all_ordered_services: [],
    visit_patient: []
};
export const getters = {
    visit_profile: state => state.visit_profile.data,
    visit_patient: state => state.visit_patient,
    profileStatus: state => state.profile_status,
    OrderServiceStatus: state => state.order_service_status,
    OrderedConsultations: state => state.ordered_consultations.data,
    OrderedProcedure: state => state.ordered_procedure.data,
    OrderedRadiology: state => state.ordered_radiologies.data,
    OrderedAntenatal: state => state.ordered_antenatal.data,
    OrderedDental: state => state.ordered_debtal.data,
    AllOrderedServices: state => state.all_ordered_services,
};

export const mutations = {
    SET_VISIT_PROFILE(state, newValue) {
        state.visit_profile = newValue
    },
    SET_VISIT_PATIENT(state, newValue) {
        state.visit_patient = newValue
    },
      CLEAR_PREV_VISIT_PATIENT(state) {
        state.visit_patient = {}
    },
    SET_PROFILE_STATUS(state, newValue) {
        state.profile_status = newValue
    },
    SET_ORDERED_CONSULTATIONS(state, newValue) {
        state.ordered_consultations = newValue
    },
    SET_ORDERED_PROCEDURE(state, newValue) {
        state.ordered_procedure = newValue
    },
    SET_ORDERED_RADIOLOGY(state, newValue) {
        state.ordered_radiologies = newValue
    },
    SET_ORDERED_ANTENATAL(state, newValue) {
        state.ordered_antenatal = newValue
    },
    SET_ORDERED_DENTAL(state, newValue) {
        state.ordered_debtal = newValue
    },
    SET_ALL_ORDERED_SERVICES(state, newValue) {
        state.all_ordered_services = newValue
    },
    EMPTY_ALL_SERVUCES_ARRAY(state) {
        state.all_ordered_services = {}
    },
    ORDER_SERVICE_STATUS(state, newValue) {
        state.order_service_status = newValue
    },
    CLEAR_CONS_ARRAY(state) {
        state.ordered_consultations = []
    },
    CLEAR_PREV_PROFILE(state) {
        state.visit_profile = {
            "data": {
                "id": "",
                "visitDate": "",
                "temp": "",
                "pressure": "",
                "weight": "",
                "muac": "",
                "pulse": "",
                "nextOfKin": "",
                "nextOfKinPhone": "",
                "patient": {
                    "id": "",
                    "patientName": "",
                    "patientContact": "",
                    "patientEmail": "",
                    "patientCode": "",
                    "NIN": "",
                    "DOB": "",
                    "patientAddress": "",
                    "clinicId": "",
                    "gender": "",
                    "status": "",
                    "visits": "",
                    "dateCreated": "",
                    "dateUpdated": ""
                },
                "labrequests": [],
                "completetests": [],
                "patientservices": [],
                "prescriptions": [],
                "discharge": "",
                "age": "",
                "status": "",
                "insurerecord": "",
                "insurepackage": "",
                "dateCreated": "",
                "dateUpdated": ""
            }
        }
    }

};
export const actions = {
      fetchVisitPatientProfile({ commit, dispatch }, visit_id) {
        commit("CLEAR_PREV_VISIT_PATIENT")
        axios.get(`visit_patient/${visit_id}`).then(vp_res => {
            commit('SET_VISIT_PATIENT', vp_res.data)
        }).catch(() => {
            let message = { 'msg': "Error fetching visit profile" }
            dispatch('notification/error', message, { root: true })
        })
    },
    fetchVisitProfile({ commit, dispatch }, visit_id) {
        commit("CLEAR_PREV_PROFILE")
        commit("EMPTY_ALL_SERVUCES_ARRAY")
        commit('SET_PROFILE_STATUS', true)
        axios.get(`visits/${visit_id}`).then(vp_res => {
            commit('SET_VISIT_PROFILE', vp_res.data)
            commit('SET_PROFILE_STATUS', false)
        }).catch(() => {
            let message = { 'msg': "Error fetching visit profile" }
            dispatch('notification/error', message, { root: true })
        })
    },
     fetchVisitProfileAlone({ commit, dispatch }, visit_id) {
        axios.get(`visits/${visit_id}`).then(vp_res => {
            commit('SET_VISIT_PROFILE', vp_res.data)
        }).catch(() => {
            let message = { 'msg': "Error fetching visit profile" }
            dispatch('notification/error', message, { root: true })
        })
    },
    closeVisit({ dispatch }, visit_id) {
        axios.delete(`visits/${visit_id}`).then(() => {
            dispatch('patients/fetchActivePatients', null, { root: true })
            dispatch('payments/fetchPatientPayments', null, { root: true })
            let message = { 'msg': "Visit closed successfully" }
                // DISPACH MESSAGE MODUL
            dispatch('notification/success', message, { root: true })

        }).catch(() => {
            let message = { 'msg': "Error closing visit" }
            dispatch('notification/error', message, { root: true })
        })
    },
    fetchOrderedConsultations({ commit }, visit_id) {
        commit('ORDER_SERVICE_STATUS', true)
        axios.get(`ordered_cons/${visit_id}`).then(oc_res => {
            commit('SET_ORDERED_CONSULTATIONS', oc_res.data)
            commit('ORDER_SERVICE_STATUS', false)
        })
    },
    fetchOrderedProcedure({ commit }, visit_id) {
        axios.get(`ordered_proc/${visit_id}`).then(op_res => {
            commit('SET_ORDERED_PROCEDURE', op_res.data)
        })
    },
    fetchOrderedRadiology({ commit }, visit_id) {
        axios.get(`ordered_radio/${visit_id}`).then(or_res => {
            commit('SET_ORDERED_RADIOLOGY', or_res.data)
        })
    },
    fetchOrderedAntenatal({ commit }, visit_id) {
        axios.get(`ordered_cons/${visit_id}`).then(a_res => {
            commit('SET_ORDERED_ANTENATAL', a_res.data)
        })
    },
    fetchOrderedDental({ commit }, visit_id) {
        axios.get(`ordered_dent/${visit_id}`).then(d_res => {
            commit('SET_ORDERED_DENTAL', d_res.data)
        })
    },
    fetchAllOrderedServices({ commit }, visit_id) {
        axios.get(`allpatient_sevices/${visit_id}`).then(all_res => {
            commit('SET_ALL_ORDERED_SERVICES', all_res.data)
        })
    },
    AddDrug({dispatch, commit }, payload) {
        commit('ORDER_SERVICE_STATUS', true)
        axios.post('prescriptions', payload).then(response => {
            commit('ORDER_SERVICE_STATUS', false)
            // dispatch('fetchVisitPrescriptions', payload.visit_id)
            if (response.status==200){
                let message = { 'msg': response.data.msg }
                dispatch('notification/success', message, { root: true })
            }else if (response.status==201){
                let message = { 'msg': response.data.msg }
                dispatch('notification/error', message, { root: true })
            }else {
                let message = { 'msg': "Error adding prescription" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('ORDER_SERVICE_STATUS', false)
            let message = { 'msg': "Error adding prescription, confirm the drug hasn't been added to the patient and try again" }
            dispatch('notification/error', message, { root: true })
        })
    },
    AddService({ dispatch, commit }, payload) {
        commit('ORDER_SERVICE_STATUS', true)
        axios.post(`addservice`, payload).then(respo => {
            dispatch('fetchAllOrderedServices', payload.visit_id)
            dispatch('fetchOrderedConsultations', payload.visit_id)
            dispatch('fetchOrderedProcedure', payload.visit_id)
            dispatch('fetchOrderedRadiology', payload.visit_id)
            dispatch('fetchOrderedDental', payload.visit_id)
            dispatch('patients/fetchActivePatients', null, { root: true })
            commit('ORDER_SERVICE_STATUS', false)
            let message = { 'msg': respo.data.state_text + ' ' + respo.data.state }
                // DISPACH MESSAGE MODUL
            if (respo.data.state === 0) {
                dispatch('notification/error', message, { root: true })
            }
            if (respo.data.state === 1) {

                dispatch('notification/success', message, { root: true })

            }
        }).catch(() => {
            commit('ORDER_SERVICE_STATUS', false)
            let message = { 'msg': "Error adding service" }
            dispatch('notification/error', message, { root: true })
        })
    },

};